
import { authorizeMe, axiosInstance} from './commonHeadApiLogic.js';

// Ensure authorization header is set before making authenticated requests
const withAuthorization = async (apiFunction, ...args) => {
  try {
    await authorizeMe(); // Ensure the Authorization header is set
    return await apiFunction(...args);
  } catch (error) {
    // Handle errors as necessary
    console.error("Error in API request:", error);
    throw error;
  }
};

export const AddPhotographerAPI = (payload) => {
  return withAuthorization(async () => {
    return axiosInstance.post(
      `/api/admins/photographers/unverified`,
      payload
    );
  });
};


export const UpdateUnverifiedPhotographerAPI = (id, payload) => {
  return withAuthorization(async () => {
    return axiosInstance.put(
      `/api/admins/photographers/unverified/${id}`,
      payload
    );
  });
};

export const DeleteUnverifiedPhotographerAPI = (id) => {
  return withAuthorization(async () => {
    return axiosInstance.delete(
      `/api/admins/photographers/unverified/${id}`
    );
  });
};



export async function getUnverifiedPhotographersAPI(page = 1,LIMIT) {
  return withAuthorization(async () => {
    // return axiosInstance.get(`/api/admins/photographers/unverified?page=${page}&limit=${LIMIT}`);
    return axiosInstance.get(`/api/admins/photographers?page=${page}&limit=${LIMIT}&status=pending`);

  });
}

export async function getRolesAPI(page = 1,LIMIT) {
  return withAuthorization(async () => {
    return axiosInstance.get(`/api/admins/roles?page=${page}&limit=${LIMIT}`);
  });
}
export const AddRoleAPI = (payload) => {
  return withAuthorization(async () => {
    return axiosInstance.post(
      `/api/admins/roles`,
      payload
    );
  });
};


export const UpdateRoleAPI = (id, payload) => {
  return withAuthorization(async () => {
    return axiosInstance.put(
      `/api/admins/roles/${id}`,
      payload
    );
  });
};

export const DeleteRoleAPI = (id) => {
  return withAuthorization(async () => {
    return axiosInstance.delete(
      `/api/admins/roles/${id}`
    );
  });
};


